import { useAlert as useAlertHook } from "components/Alerts/hooks"
import { alerts } from "keys"
import { useCallback } from "react"

const useAlert = () => {
    const { setAlerts } = useAlertHook()

    const handleContactUsAlert = useCallback((value) => {
        setAlerts(alerts.contactUs, value)
    }, [])

    return handleContactUsAlert
}

export default useAlert